import React, { useEffect, useState, useCallback } from "react";
import BaseURL from "../../../assets/utils/baseUrl";
import MUIDataTable from "mui-datatables";
import { Button, Footer, HeaderAdmin } from "../../../components";
import { TextField } from "@material-ui/core";
import { Loader } from "../../../assets";

// ======================================================
// Helper: sanitasi string untuk render aman
// ======================================================
const sanitizeText = (value) => {
  if (typeof value !== "string") return "";
  return value.replace(/</g, "&lt;").replace(/>/g, "&gt;");
};

// ======================================================
// Helper: URL thumbnail aman (hanya izinkan path relatif)
// ======================================================
const buildThumbnailUrl = (filename) => {
  if (!filename || typeof filename !== "string") return null;
  // Cegah path traversal
  if (filename.includes("..") || filename.includes("/") || filename.includes("\\")) return null;
  // Hanya izinkan ekstensi gambar
  if (!/\.(jpg|jpeg|png|gif|webp)$/i.test(filename)) return null;
  return BaseURL + "assets/images/banner/" + encodeURIComponent(filename);
};

// ======================================================
// Helper: ambil token autentikasi (JANGAN pakai id langsung)
// Sesuaikan dengan sistem auth Anda (JWT di localStorage/cookie)
// ======================================================
const getAuthHeaders = () => {
  const token = localStorage.getItem("token"); // ganti key sesuai implementasi
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ======================================================
// Nama bulan ke angka (perbaikan bug fall-through switch)
// ======================================================
const MONTH_MAP = {
  Januari: "01", Februari: "02", Maret: "03", April: "04",
  Mei: "05", Juni: "06", Juli: "07", Agustus: "08",
  September: "09", Oktober: "10", November: "11", Desember: "12",
};

function KelolaBanner({ setToken }) {
  const [banner, setBanner]                   = useState([]);
  const [modal, setModal]                     = useState(false);
  const [updateModal, setUpdateModal]         = useState(false);
  const [popUp, setPopUp]                     = useState(false);
  const [success, setSuccess]                 = useState(true);
  const [load, setLoad]                       = useState(true);
  const [loading, setLoading]                 = useState(true);
  const [alertJudul, setAlertJudul]           = useState(false);
  const [alertLink, setAlertLink]             = useState(false);
  const [alertThumbnail, setAlertThumbnail]   = useState(false);
  const [formData, setFormData]               = useState({
    judul: "",
    link: "",
    thumbnail: null,
    created_date: "",
  });
  const [id, setId] = useState("");
  const [tableData, setTableData] = useState([]);

  // ======================================================
  // FETCH DATA BANNER
  // ======================================================
  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const res  = await fetch(BaseURL + "index.php/api/Banner", {
          headers: getAuthHeaders(),
        });
        if (!res.ok) throw new Error("Response tidak OK: " + res.status);
        const data = await res.json();
        setBanner(Array.isArray(data.data) ? data.data : []);
      } catch (err) {
        console.error("Gagal fetch banner:", err);
        setBanner([]);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [load]);

  // ======================================================
  // BUILD TABLE DATA
  // ======================================================
  useEffect(() => {
    if (banner.length > 0) {
      const tablesData = banner.map((item) => ({
        judul:        item.judul,
        link:         item.link,
        tanggal_post: item.created_date,
        thumbnail:    item.thumbnail, // nama file saja, URL dibangun di render
        opsi:         item.id_banner,
      }));
      setTableData(tablesData);
    } else {
      setTableData([]);
    }
  }, [banner]);

  // ======================================================
  // VALIDASI FORM
  // ======================================================
  const validateForm = useCallback((requireThumbnail = true) => {
    let valid = true;

    if (!formData.judul.trim()) {
      setAlertJudul(true);
      valid = false;
    } else {
      setAlertJudul(false);
    }

    // Validasi link: harus http/https
    const linkTrimmed = formData.link.trim();
    if (!linkTrimmed || !/^https?:\/\//i.test(linkTrimmed)) {
      setAlertLink(true);
      valid = false;
    } else {
      setAlertLink(false);
    }

    if (requireThumbnail && formData.thumbnail === null) {
      setAlertThumbnail(true);
      valid = false;
    } else {
      setAlertThumbnail(false);
    }

    return valid;
  }, [formData]);

  // ======================================================
  // RESET FORM
  // ======================================================
  const resetForm = () => {
    setFormData({ judul: "", link: "", thumbnail: null, created_date: "" });
    setAlertJudul(false);
    setAlertLink(false);
    setAlertThumbnail(false);
  };

  // ======================================================
  // TAMBAH BANNER
  // ======================================================
   const tambah = async () => {
    if (!validateForm(true)) return;

    const data = new FormData();
    const today = new Date();
    const date  = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

    data.append("request", "post");
    data.append("judul", formData.judul.trim());
    data.append("link", formData.link.trim());
    // JANGAN kirim id_user dari localStorage langsung —
    // server harus membaca dari token/session autentikasi
    data.append("created_date", date);
    data.append("image", formData.thumbnail);

    try {
      const response = await fetch(BaseURL + "index.php/api/Banner", {
        method:  "POST",
        headers: getAuthHeaders(), // token dikirim via header
        body:    data,
      });
      const result = await response.json();
      resetForm();
      setLoad((prev) => !prev);
      setModal(false);
      setUpdateModal(false);
      setSuccess(!!result.status);
      setPopUp(true);
    } catch (error) {
      console.error("Gagal tambah banner:", error);
      setSuccess(false);
      setPopUp(true);
    }
  };

  // ======================================================
  // HAPUS BANNER
  // ======================================================
  const hapus = async (idBanner) => {
    const idInt = parseInt(idBanner, 10);
    if (!Number.isInteger(idInt) || idInt <= 0) {
      console.error("ID tidak valid");
      return;
    }

    try {
      const response = await fetch(BaseURL + "index.php/api/Banner/" + idInt, {
        method:  "DELETE",
        headers: getAuthHeaders(),
      });
      const result = await response.json();
      setLoad((prev) => !prev);
      setSuccess(!!result.status);
      setPopUp(true);
    } catch (error) {
      console.error("Gagal hapus banner:", error);
      setSuccess(false);
      setPopUp(true);
    }
  };

  // ======================================================
  // BUKA MODAL UPDATE
  // ======================================================
  const openUpdateModal = async (idBanner) => {
    const idInt = parseInt(idBanner, 10);
    if (!Number.isInteger(idInt) || idInt <= 0) return;

    try {
      const res  = await fetch(BaseURL + "index.php/api/Banner?id=" + idInt, {
        headers: getAuthHeaders(),
      });
      if (!res.ok) throw new Error("Response tidak OK");
      const data = await res.json();

      if (!data.data || !data.data[0]) throw new Error("Data tidak ditemukan");

      // Perbaikan bug switch fall-through: gunakan object map
      const parts = (data.data[0].created_date || "").split(" ");
      let createdDate = "";
      if (parts.length >= 3) {
        const month = MONTH_MAP[parts[1]] || "01";
        createdDate = `${parts[2]}-${month}-${parts[0]}`;
      }

      setFormData((prev) => ({
        ...prev,
        judul:        data.data[0].judul || "",
        link:         data.data[0].link  || "",
        created_date: createdDate,
        thumbnail:    null, // jangan prefill file input
      }));
      setId(idInt);
      setModal(true);
    } catch (err) {
      console.error("Gagal ambil data update:", err);
    }
  };

  // ======================================================
  // UPDATE BANNER
  // ======================================================
  const update = async () => {
    if (!validateForm(false)) return; // thumbnail opsional saat update

    const data   = new FormData();
    const today  = new Date();
    const date   = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

    data.append("request", "put");
    data.append("id_banner", id);
    data.append("judul", formData.judul.trim());
    data.append("link", formData.link.trim());
    data.append("created_date", formData.created_date);
    data.append("updated_date", date);
    if (formData.thumbnail) {
      data.append("image", formData.thumbnail);
    }

    try {
      const response = await fetch(BaseURL + "index.php/api/Banner", {
        method:  "POST",
        headers: getAuthHeaders(),
        body:    data,
      });
      const result = await response.json();
      resetForm();
      setLoad((prev) => !prev);
      setModal(false);
      setUpdateModal(false);
      setSuccess(!!result.status);
      setPopUp(true);
    } catch (error) {
      console.error("Gagal update banner:", error);
      setSuccess(false);
      setPopUp(true);
    }
  };

  // ======================================================
  // KOLOM TABEL
  // ======================================================
  const columns = [
    {
      name: "judul",
      label: "Judul",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <div style={{ width: 200 }}>{sanitizeText(value)}</div>
        ),
      },
    },
    {
      name: "link",
      label: "Link",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          const safe = sanitizeText(value);
          // Hanya render link jika http/https
          if (/^https?:\/\//i.test(value)) {
            return <a href={safe} target="_blank" rel="noopener noreferrer">{safe}</a>;
          }
          return <span>{safe}</span>;
        },
      },
    },
    {
      name: "tanggal_post",
      label: "Tanggal Post",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => (
          <div style={{ width: 100 }}>{sanitizeText(value)}</div>
        ),
      },
    },
    {
      name: "thumbnail",
      label: "Thumbnail",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          const src = buildThumbnailUrl(value);
          return src
            ? <img src={src} alt="thumbnail banner" style={{ width: 150, objectFit: "contain" }} />
            : <span>-</span>;
        },
      },
    },
    {
      name: "opsi",
      label: "Opsi",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div className="tooltip btn-hapus-row" onClick={() => hapus(value)}>
              <i className="fas fa-trash-alt"></i>
              <span className="tooltiptext">Hapus</span>
            </div>
            <div
              className="tooltip btn-edit-row"
              onClick={() => {
                setUpdateModal(true);
                openUpdateModal(value);
              }}
            >
              <i className="fas fa-edit"></i>
              <span className="tooltiptext">Update</span>
            </div>
          </div>
        ),
      },
    },
  ];

  const options = {
    sort: true,
    filter: false,
    download: false,
    print: false,
    selectableRows: "none",
  };

  // ======================================================
  // RENDER
  // ======================================================
  return (
    <div className="page">
      <HeaderAdmin title="Kelola Banner" setToken={(e) => setToken(e)} />
      <div className="main-admin">
        <div className="container-admin">
          <div style={{ height: 50 }} />
          <Button
            title="Tambah Post"
            type="primary"
            onClick={() => {
              resetForm();
              setUpdateModal(false);
              setModal(true);
            }}
          />
          <div style={{ height: 10 }} />
          {loading ? (
            <div className="loader">
              <img src={Loader} alt="loading" />
            </div>
          ) : (
            <MUIDataTable
              title={"Daftar Banner"}
              data={tableData}
              columns={columns}
              options={options}
              className="table"
            />
          )}
        </div>
      </div>

      <Footer />

      {/* Modal tambah / update */}
      <div className={modal ? "darker-bg-admin" : "darker-bg-admin hide"}>
        <div className="modal-admin">
          <div className="form-admin">
            <TextField
              id="judul"
              label="Judul"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) => setFormData({ ...formData, judul: e.target.value })}
              value={formData.judul}
              inputProps={{ maxLength: 255 }}
            />
            {alertJudul && <div className="danger-alert">Judul tidak boleh kosong</div>}

            <TextField
              id="link"
              label="Link (https://...)"
              variant="outlined"
              style={{ marginTop: 10, marginBottom: 10 }}
              onChange={(e) => setFormData({ ...formData, link: e.target.value })}
              value={formData.link}
              inputProps={{ maxLength: 500 }}
            />
            {alertLink && <div className="danger-alert">Link tidak valid (harus dimulai https:// atau http://)</div>}

            <div style={{ height: 10 }} />

            <div className="btn-thumbnail">
              <Button title="Pilih thumbnail" type="secondary" />
              <span className="file-name">
                {formData.thumbnail != null
                  ? formData.thumbnail.name
                  : updateModal
                  ? "(Kosongkan jika tidak ingin mengubah thumbnail)"
                  : "(Belum memilih gambar/thumbnail)"}
              </span>
              <input
                className="invisible-input"
                type="file"
                title="Pilih thumbnail"
                accept="image/jpeg,image/png,image/webp,image/gif"
                onChange={(e) => setFormData({ ...formData, thumbnail: e.target.files[0] || null })}
              />
            </div>
            {alertThumbnail && <div className="danger-alert">Thumbnail tidak boleh kosong</div>}
          </div>

          <div style={{ height: 30 }} />

          <div className="form-option">
            <Button
              title={updateModal ? "Update" : "Tambah"}
              type="primary"
              onClick={() => (updateModal ? update() : tambah())}
            />
            <div style={{ width: 10 }} />
            <Button
              title="Batal"
              type="danger"
              onClick={() => {
                setModal(false);
                setUpdateModal(false);
                resetForm();
              }}
            />
          </div>
        </div>
      </div>

      {/* Pop-up status */}
      <div className={popUp ? "darker-bg-admin" : "darker-bg-admin hide"}>
        <div className="pop-up-admin">
          <i className={success ? "fas fa-check-circle pop-up-logo" : "fas fa-times-circle pop-up-logo failed-pop-up"} />
          {success ? <p>Berhasil</p> : <p className="failed-pop-up">Gagal</p>}
          <div style={{ height: 20 }} />
          <Button
            title="Tutup"
            type="primary"
            onClick={() => {
              setAlertJudul(false);
              setAlertLink(false);
              setAlertThumbnail(false);
              setPopUp(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default KelolaBanner;
